import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditExclusiveIndex extends Component {

    state = {
        exclusiveIndex: this.props.exclusiveIndex,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { exclusiveIndex = '' } = this.state

        return (
            <Modal
                narrow
                extraClassName="EditExclusiveIndex"
                onCancel={this.props.onClose}
                onSave={this.onSave}
                saveText="Save"
                mode="edit"
                title="Exclusive Index">
                <Form>
                    <div>
                        <input
                            type="number"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            placeholder="Exclusive Index"
                            value={exclusiveIndex}
                            onChange={e => this.setState({ exclusiveIndex: e.target.value })} />
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default EditExclusiveIndex



// WEBPACK FOOTER //
// ./src/components/LBUs/EditExclusiveIndex.js